(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-spj"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.stickyType = this.getAttribute('data-sticky-type') || 'none';
      this.headerIsAlwaysSticky =
        this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerBounds = {
        top: 0,
        bottom: this.header ? this.header.offsetHeight : 0,
      };

      if (!this.header) return;

      this.setHeaderHeight();

      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.onMediaChange = this.setHeaderHeight.bind(this);
      this.mediaQuery.addEventListener('change', this.onMediaChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
      this.onScroll();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.mediaQuery && this.onMediaChange) {
        this.mediaQuery.removeEventListener('change', this.onMediaChange);
      }
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        const bounds = entries[0].boundingClientRect;

        this.headerBounds = {
          top: bounds.top,
          bottom: bounds.bottom,
        };

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.stickyType === 'reduce-logo-size') {
        const shouldCompact = scrollTop > 24;

        this.header.classList.toggle('scrolled-past-header', shouldCompact);
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden', 'animate');

        if (shouldCompact !== this.wasCompact) {
          this.wasCompact = shouldCompact;
          window.requestAnimationFrame(() => this.setHeaderHeight());
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      const boundaryBottom = this.headerBounds.bottom || this.header.offsetHeight;

      if (scrollTop > this.currentScrollTop && scrollTop > boundaryBottom) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        window.requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > boundaryBottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          window.requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = window.setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          window.requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        window.requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());

      this.header.querySelectorAll('.spj-split-header__dropdown[open]').forEach((dropdown) => {
        dropdown.removeAttribute('open');
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  if (!window.spjSplitHeaderDropdownsInitialized) {
    window.spjSplitHeaderDropdownsInitialized = true;

    document.addEventListener('click', (event) => {
      const clickedDropdown = event.target.closest('.spj-split-header__dropdown');
      const clickedSummary = event.target.closest('.spj-split-header__dropdown > summary');

      document.querySelectorAll('.spj-split-header__dropdown[open]').forEach((dropdown) => {
        if (clickedSummary && dropdown === clickedSummary.parentElement) return;
        if (clickedDropdown && dropdown === clickedDropdown) return;
        dropdown.removeAttribute('open');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('.spj-split-header__dropdown[open]').forEach((dropdown) => {
        dropdown.removeAttribute('open');
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.stickyType = this.getAttribute('data-sticky-type') || 'none';
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerBounds = {
        top: 0,
        bottom: this.header ? this.header.offsetHeight : 0,
      };

      if (!this.header) return;

      this.setHeaderHeight();

      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.onMediaChange = this.setHeaderHeight.bind(this);
      this.mediaQuery.addEventListener('change', this.onMediaChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
      this.onScroll();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.mediaQuery && this.onMediaChange) {
        this.mediaQuery.removeEventListener('change', this.onMediaChange);
      }
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        const bounds = entries[0].boundingClientRect;

        this.headerBounds = {
          top: bounds.top,
          bottom: bounds.bottom,
        };

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.stickyType === 'reduce-logo-size') {
        const shouldCompact = scrollTop > 24;

        this.header.classList.toggle('scrolled-past-header', shouldCompact);
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden', 'animate');

        if (shouldCompact !== this.wasCompact) {
          this.wasCompact = shouldCompact;
          window.requestAnimationFrame(() => this.setHeaderHeight());
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      const boundaryBottom = this.headerBounds.bottom || this.header.offsetHeight;

      if (scrollTop > this.currentScrollTop && scrollTop > boundaryBottom) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        window.requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > boundaryBottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          window.requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = window.setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          window.requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        window.requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
